import { ifInTestingMode } from 'utils/tests.utils';
import { ButtonsContainer, SaveCancelContainer, CancelButton, SaveButton, SaveNewButton } from './styles';
import { FormattedMessage } from 'react-intl';

function Actions(props: {
  visible: boolean;
  loading: boolean;
  update: boolean;
  onCancel: () => void;
  onSave: (viewName: string) => void;
  onSaveAsNew: () => void;
}) {
  if (!props.visible) {
    return null;
  }

  return (
    <ButtonsContainer>
      <SaveCancelContainer>
        <CancelButton
          data-testid={ifInTestingMode('filters__cancel')}
          onClick={props.onCancel}
          disabled={props.loading}
        />
        <SaveButton data-testid={ifInTestingMode('filters__update')} onClick={props.onSave} disabled={props.loading} />
      </SaveCancelContainer>

      {props.update && (
        <SaveNewButton
          data-testid={ifInTestingMode('filters__save_new')}
          onClick={props.onSaveAsNew}
          disabled={props.loading}
        >
          <FormattedMessage id="buttons.saveAsNew" />
        </SaveNewButton>
      )}
    </ButtonsContainer>
  );
}

export default Actions;
